import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { PublicBoxQuestionnaireFileResponse } from '@web/shared/module/shop';
import { AdminBoxQuestionnaireQuestionOptionSourceResponse } from './admin-box-questionnaire-question-option-source.response';
import { AdminBoxQuestionnaireQuestionOptionAttributeResponse } from './admin-box-questionnaire-question-option-attribute.response';

@jsonObject
export class AdminBoxQuestionnaireQuestionOptionResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isSelected!: boolean;

  @jsonMember(Boolean)
  public readonly isAutoSelected?: Nillable<boolean>;

  @jsonMember(Boolean)
  public readonly isAvailable!: boolean;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(Number)
  public readonly remainingQuantity?: Nillable<number>;

  @jsonMember(PublicBoxQuestionnaireFileResponse)
  public readonly featureFile?: Nillable<PublicBoxQuestionnaireFileResponse>;

  @jsonMember(AdminBoxQuestionnaireQuestionOptionSourceResponse)
  public readonly source?: Nillable<AdminBoxQuestionnaireQuestionOptionSourceResponse>;

  @jsonArrayMember(AdminBoxQuestionnaireQuestionOptionAttributeResponse)
  public readonly attributes?: AdminBoxQuestionnaireQuestionOptionAttributeResponse[];
}
